import {forwardRef} from 'react'
import styles from './ImpactInput.module.css'

interface ImpactInputProps {
    type?: 'text' | 'number' | 'date' | 'email'
    variant?: 'light' | 'dark'
    value: string | number
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    onFocus?: () => void
    onBlur?: () => void
    disabled?: boolean
    placeholder?: string
    min?: string | number
    max?: string | number
    step?: string | number
    className?: string
    id?: string
    isInvalid?: boolean
    inputMode?: React.HTMLAttributes<HTMLInputElement>['inputMode']
    autoComplete?: string
}

const ImpactInput = forwardRef<HTMLInputElement, ImpactInputProps>(({
    type = 'text',
    variant = 'light',
    value,
    onChange,
    onFocus,
    onBlur,
    disabled = false,
    placeholder,
    min,
    max,
    step,
    className = '',
    id,
    isInvalid = false,
    inputMode,
    autoComplete
}, ref) => {
    const variantClass = variant === 'dark' ? styles.inputDark : styles.inputLight
    const invalidClass = isInvalid ? styles.invalid : ''
    const resolvedAutoComplete = autoComplete ?? (type === 'date' ? 'off' : undefined)

    return (
        <input
            ref={ref}
            id={id}
            type={type}
            className={`${variantClass} ${invalidClass} ${className}`.trim()}
            value={value}
            onChange={onChange}
            onFocus={onFocus}
            onBlur={onBlur}
            disabled={disabled}
            placeholder={placeholder}
            min={min}
            max={max}
            step={step}
            inputMode={inputMode}
            autoComplete={resolvedAutoComplete}
        />
    )
})

ImpactInput.displayName = 'ImpactInput'

export default ImpactInput
